const monthNames = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

/**
 * Generates an array of month options for the past 12 months plus "All".
 * Returns [{ value: "YYYY-MM", label: "Month Year" }, ..., { value: "all", label: "All" }]
 * Current month is first, then descending chronological order.
 */
export const generateMonthOptions = () => {
  const now = new Date();
  const options = [];

  for (let i = 0; i < 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    options.push({
      value: `${year}-${month}`,
      label: `${monthNames[d.getMonth()]} ${year}`,
    });
  }

  options.push({ value: 'all', label: 'All' });
  return options;
};

/**
 * Converts a month value ("YYYY-MM" or "all") to a date range.
 * Returns { dateStart: Date, dateEnd: Date } or null when "all".
 */
export const getMonthDateRange = (monthValue) => {
  if (!monthValue || monthValue === 'all') return null;

  const [year, month] = monthValue.split('-').map(Number);
  const dateStart = new Date(year, month - 1, 1);
  const dateEnd = new Date(year, month, 0, 23, 59, 59, 999);
  return { dateStart, dateEnd };
};

/**
 * Parses a month filter value into year and month numbers for API query params.
 * "2026-03" → { year: 2026, month: 3 }
 * "all" or falsy → null (omit params to fetch all)
 */
export const parseMonthValue = (monthValue) => {
  if (!monthValue || monthValue === 'all') return null;
  const [year, month] = monthValue.split('-').map(Number);
  return { year, month };
};

/**
 * Returns the display name for a month value.
 * "2026-03" → "March 2026", "all" → "All Time"
 */
export const getMonthDisplayName = (monthValue) => {
  if (!monthValue || monthValue === 'all') return 'All Time';
  const [year, month] = monthValue.split('-').map(Number);
  return `${monthNames[month - 1]} ${year}`;
};
